import { Toaster, toast } from "sonner";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import { useRef } from "react";
import sound from "./audio/bg-music2.mp3";
import UserProvider from "./components/context/UseContext";
import AppRoutes from "./routes/AppRoutes";
import "./api/Interceptor";

function App() {
  const audioRef = useRef(null);

  return (
    <>
      <HelmetProvider>
        <UserProvider>
          <BrowserRouter>
            <AppRoutes ref={audioRef} />
          </BrowserRouter>
        </UserProvider>
      </HelmetProvider>
      <audio ref={audioRef} src={sound} preload="auto" loop />
      <Toaster
        richColors
        duration={3000}
        position="top-right"
        onDismiss={toast.dismiss()}
      />
    </>
  );
}

export default App;
